import React from 'react';
import AgreementModal from './AgreementModal';
import PolicyModal from './PolicyModal';

/** Передаём только show и onClose; client модалки достают из Redux через селектор в withModalForm */
const ModalManager = ({
  isAgreementModalOpen,
  isPolicyModalOpen,
  onAgreementClose,
  onPolicyClose,
}) => (
  <>
    <AgreementModal show={isAgreementModalOpen} onClose={onAgreementClose} />
    <PolicyModal show={isPolicyModalOpen} onClose={onPolicyClose} />
  </>
);

export default ModalManager;
